module.exports = __webpack_public_path__ + "img/wagner_sm.11ee5b5a.png";